import { Modal } from "antd";
import useListarContaCategoria from "core/features/contas-categorias/hooks/useListarContaCategoria";
import { DemonstrativoReceitaEDespesaItem } from "core/features/relatorios/typings";
import { Flex } from "@chakra-ui/layout";

import PrimaryButton from "ui/components/Button/PrimaryButton";
import { OperacaoEnum } from "core/resources/enums/conta";
import { FindContasByCategoriaQueryParams } from "core/features/contas-categorias/typings/index";
import { useState } from "react";
import useDetalhamentoContaCategoriaColumns from "./useDetalhamentoContaCategoriaColumns";
import NewTable from "ui/components/NewTable";
import { useEffect } from "react";

interface ModalDetalhamentoContaCategoriaProps {
  isOpenModal: boolean;
  onClose: () => any;
  id: string | undefined;
  item?: Partial<DemonstrativoReceitaEDespesaItem>;
  params?: FindContasByCategoriaQueryParams;
}

function ModalDetalhamentoContaCategoria({
  isOpenModal,
  onClose,
  id,
  item,
  params,
}: ModalDetalhamentoContaCategoriaProps) {
  const columns = useDetalhamentoContaCategoriaColumns(item?.operacao);
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
  });
  const { data, isLoading } = useListarContaCategoria(id, {
    ...params,
    ...pagination,
  });

  useEffect(() => {
    return () => {
      if (!isOpenModal) {
        setPagination({
          page: 1,
          limit: 10,
        });
      }
    };
  }, [isOpenModal]);

  const tituloModal =
    item?.operacao === OperacaoEnum.Receita ? "Receber" : "Pagar";

  return (
    <Modal
      centered
      title={`Contas a ${tituloModal}${
        item ? ` - ${item.breadcrumb ?? ""} ${item?.nome}` : ""
      }`}
      visible={isOpenModal}
      footer={
        <Flex flex={1} justifyContent="end">
          <PrimaryButton onClick={onClose}>Fechar</PrimaryButton>
        </Flex>
      }
      onCancel={onClose}
      destroyOnClose
      width="900px"
    >
      <NewTable
        columns={columns}
        dataSource={data?.items}
        loading={isLoading}
        customPagination={{
          onChangePage: (page, perPage) => {
            setPagination({ page, limit: perPage });
          },
          currentPage: pagination.page,
          itemsPerPage: data?.meta.itemsPerPage,
          totalItems: data?.meta.totalItems,
        }}
      />
    </Modal>
  );
}

export default ModalDetalhamentoContaCategoria;
